import { marginVariants } from "@/types";
import { tv } from "@/utils/tv.config";
import { type VariantProps } from "tailwind-variants";

export const boxClasses = tv({
  extend: marginVariants,
  base: ["Box__root"],
  variants: {
    p: {
      sm: ["p-2"],
      md: ["p-4"],
      lg: ["p-6"],
    },
    bordered: {
      true: ["border"],
    },
    rounded: {
      true: ["rounded"],
    },
    flex: {
      true: ["flex"],
    },
    justifyContent: {
      center: ["justify-center"],
      flexStart: ["justify-start"],
      flexEnd: ["justify-end"],
      around: ["justify-around"],
      between: ["justify-between"],
      evenly: ["justify-evenly"],
    },
    alignItems: {
      center: ["items-center"],
      baseline: ["items-baseline"],
      flexStart: ["items-start"],
      flexEnd: ["items-end"],
      around: ["items-around"],
      between: ["items-between"],
      evenly: ["items-evenly"],
    },
    flexDirection: {
      row: ["flex-row"],
      col: ["flex-col"],
      rowRev: ["flex-row-reverse"],
      colRev: ["flex-col-reverse"],
    },
  },
  defaultVariants: {},
});

export type BoxVariants = VariantProps<typeof boxClasses>;
